import React, { useState, KeyboardEvent } from 'react';
import './styles.scss';
import _uniqueId from 'lodash/uniqueId';
import { Label } from '../Label';
import { InputPropsBase } from '../interfaces/Inputs';
import { InputContainer } from '../InputContainer';
import { Alignment, JustifyContents } from '../../layout';
import { Variant } from '../models';

interface InputCheckBoxProps extends InputPropsBase<boolean, boolean> {
    uncontrolled?: boolean;
    indeterminate?: boolean;
    additionalInfo?: string;
    additionalInfoClassName?: string;
    isUsedInDropdown?: boolean;
}

export function InputCheckBox(props: InputCheckBoxProps): JSX.Element {
    const marginTopOffset = 2;
    const [checked, setChecked] = useState(props.value);
    const id = _uniqueId('id-');

    function handleKeyPress(e: KeyboardEvent) {
        e.preventDefault();
        if (!props.uncontrolled) setChecked(!checked);
    }
    const onBlur = () => {
        props.onBlur && props.onBlur(props.value);
    };
    return (
        <InputContainer
            gap={props.gap || 15}
            justify={props.justify || JustifyContents.flexStart}
            align={props.align || Alignment.flexStart}
            overflow={props.overflow}
            onKeyDown={e => {
                handleKeyPress(e);
            }}
            width={props.width || 'auto'}
            height={props.height}
        >
            <Label
                id={props.uncontrolled ? props.id : id}
                content={props.label}
                disabled={props.disabled === true}
                labelPosition={props.labelPosition}
                labelLength={props.additionalInfo ? 2 : props.labelLength || 0}
                className={props.labelClassName}
                textOverflow={props.isUsedInDropdown}
            >
                <div
                    className={'checkbox-element'}
                    style={{
                        flex: props.inputLength || 0,
                        marginTop: props.align !== Alignment.center ? marginTopOffset : undefined,
                    }}
                >
                    <input
                        type="checkbox"
                        className={
                            'checkbox-element ' +
                            (props.variant === Variant.Toolbar ? ` toolbar ` : '') +
                            (props.indeterminate ? 'indeterminate' : 'normal') +
                            (props.disabled === 'inputOnly' || props.disabled === true ? ' disabled' : '')
                        }
                        name={props.name}
                        id={props.uncontrolled ? props.id : id}
                        checked={props.value}
                        disabled={props.disabled === 'inputOnly' || props.disabled === true}
                        onChange={e => props.onChange && props.onChange(e.target.checked)}
                        onBlur={onBlur}
                        tabIndex={props.tabIndex}
                    />
                </div>
            </Label>
            {props.additionalInfo && (
                <Label className={`additionalInfo ${props.additionalInfoClassName}`} content={props.additionalInfo} />
            )}
        </InputContainer>
    );
}
